import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, useLocation } from 'react-router-dom';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { getMe } from '../utils/api';
import Loader from './Loader';
import { Col, Container, Row } from 'react-bootstrap';
import Sidebar from './Sidebar';
import { Outlet } from 'react-router-dom';
import { useDataStore } from '../Store';
import Error from './Error';


const Dashboard = () => {
    const setUser = useDataStore((state) => state.setUser);
    const setSelectedEntity = useDataStore((state) => state.setSelectedEntity);
    const setSelectedDealer = useDataStore((state) => state.setSelectedDealer);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [sidebarIsOpen, setSidebarIsOpen] = useState(true);

    useEffect(() => {
        const fetchCompanies = async () => {
            const data = await getMe();
            if (data) {
                setUser(data);
                setSelectedDealer(data?.SelectedDealer);
                setSelectedEntity(data?.SelectedEntity);

                setData(data);
            }
            else {
                setError('Failed to fetch data');
            }
            setLoading(false);
        };
        fetchCompanies();
    }, []);

    if (loading) {
        return <Loader />;
    }

    if (error) {
        return <div>{error}</div>;
    }


    const dealerChanged = (event) => {
        setSelectedDealer(event.target.value);
    }
    const entityChanged = (event) => {
        setSelectedEntity(event.target.value);

        const dealers = data?.Entities?.find(c => c.Id == event.target.value)?.Dealers;
        setSelectedDealer(dealers?.[0]?.Id || 0);
    }
    const toggleOpenClosed = (event) => {
        setSidebarIsOpen(!sidebarIsOpen);
    }
    return (
        <div style={{ position: 'relative', height: '100%' }}>
            <div style={{ height: '100%', overflow: 'auto' }}>
                <Container fluid className="px-0 h-100">
                    {data.Entities?.length > 0 ?
                        <Row className="g-0 h-100 flex-nowrap">
                            <Col xs="auto" style={{ width: sidebarIsOpen ? '200px' : '50px' }}>
                                <Sidebar
                                    user={data}
                                    entityChanged={entityChanged}
                                    dealerChanged={dealerChanged}
                                    toggleOpenClosed={toggleOpenClosed}
                                    isOpen={sidebarIsOpen}
                                />
                            </Col>
                            <Col className="flex-grow-1 overflow-auto">
                                <Outlet />
                            </Col>
                        </Row>
                        :
                        <Row className="g-0 h-100 flex-nowrap justify-content-center align-items-center">
                            <Error text="No entities assigned. Contact Administrator" />
                        </Row>
                    }
                </Container>
            </div>
        </div>
    );
};

export default withAuthenticationRequired(Dashboard);
